// extracted by mini-css-extract-plugin
export var accordionList = "style-mod--accordion-list--a307c";
export var ccBody = "style-mod--cc-body--06d8d";
export var customServiceModal = "style-mod--custom-service-modal--f876a";
export var modalClose = "style-mod--modal-close--3b7c7";
export var modalCloseContainer = "style-mod--modal-close-container--fa7ad";
export var modalCloseDesktop = "style-mod--modal-close-desktop--b6f85";
export var modalCloseDesktopDesktop = "style-mod--modal-close-desktop-desktop--26666";
export var modalCloseDesktopResponsive = "style-mod--modal-close-desktop-responsive--7a78d";
export var modalCloseResponsive = "style-mod--modal-close-responsive--dad58";
export var modalParagraph = "style-mod--modal-paragraph--6af55";
export var modalTitle = "style-mod--modal-title--81145";
export var recoatingServiceAccordion = "style-mod--recoating-service-accordion--a8a14";
export var recoatingServiceAccordionTitle = "style-mod--recoating-service-accordion-title--0f457";
export var recoatingServiceContent = "style-mod--recoating-service-content--e421c";
export var recoatingServiceHead = "style-mod--recoating-service-head--38a90";
export var recoatingServiceModal = "style-mod--recoating-service-modal--c5acc";
export var serviceContent = "style-mod--service-content--f24bc";
export var serviceTitle = "style-mod--service-title--f9797";